// Copyright 2024 The Lynx Authors. All rights reserved.
// Licensed under the Apache License Version 2.0 that can be found in the
// LICENSE file in the root directory of this source tree.
export const DIFF = '__b';
export const DIFF2 = '_diff2';
export const RENDER = '__r';
export const DIFFED = 'diffed';
export const COMMIT = '__c';
export const SKIP_EFFECTS = '__s';
export const CATCH_ERROR = '__e';
export const ROOT = '__';
export const RENDER_COMPONENT = 'renderComponent';

// VNode properties
export const COMPONENT = '__c';
export const CHILDREN = '__k';
export const PARENT = '__';
export const MASK = '__m';
export const DOM = '__e';
export const ORIGINAL = '__v';
export const INDEX = '__i';
export const FLAGS = '__u';

// Component properties
export const VNODE = '__v';
// Preact 11 merged the `_dirty` / `_force` / error booleans into a `_bits`
// bitfield (`COMPONENT_DIRTY = 1 << 3`, `COMPONENT_FORCE = 1 << 2`).
export const BITS = '__g';
export const COMPONENT_DIRTY: number = 1 << 3;
export const COMPONENT_FORCE: number = 1 << 2;
export const NEXT_STATE = '__s';
export const GLOBAL_CONTEXT = '__n';
export const CHILD_DID_SUSPEND = '__c';
export const RENDER_CALLBACKS = '__h';
export const HOOK = '__h';

// Hooks properties
export const HOOKS = '__H';
export const LIST = '__';
export const VALUE = '__';
export const NEXT_VALUE = '__N';
export const PENDING_EFFECTS = '__h';
